import slide1 from "../../images/banner1.jpg";
import slide2 from "../../images/banner2.jpg";
import slide3 from "../../images/slide3.jpg";

export const sliderData = [
    {
        image: slide1,
        heading: "Transforming Nigeria Into A Global Healthcare Frontier",
        // paragragh: "We do this within a system that is ethical, knowledge-driven, innovative, and accessible. We ensure that empathy for the patient runs through all our actions while we benchmark against world class standards.",
    },
    {
        image: slide3,
        heading: "Fostering Multi-specialty Clinical Excellence Across Target Locations",
        // paragragh: "We do this within a system that is ethical, knowledge-driven, innovative, and accessible. We ensure that empathy for the patient runs through all our actions while we benchmark against world class standards.",
    },
    {
        image: slide2,
        heading: " Promoting Investor Confidence Through Optimal Value Delivery",
        // paragragh: "We do this within a system that is ethical, knowledge-driven, innovative, and accessible. We ensure that empathy for the patient runs through all our actions while we benchmark against world class standards.",
    },
    // {
    //     image: 'https://res.cloudinary.com/dbz1rgohb/image/upload/v1722290226/DOCH_108-01_jcm3uw_jkutdt.jpg',
    //     heading: "We Will Look After You",
    //     // paragragh: "We do this within a system that is ethical, knowledge-driven, innovative, and accessible. We ensure that empathy for the patient runs through all our actions while we benchmark against world class standards.",
    // },
]